export const highlightPosition = (x: number, y: number, removeAfterMs: number = 1000): void => {
	const highlightEl = document.createElement('div')
	highlightEl.style.position = 'absolute'
	// Adjust to center the highlight on (x, y)
	highlightEl.style.left = `${x - 5}px`
	highlightEl.style.top = `${y - 5}px`
	highlightEl.style.width = '10px'
	highlightEl.style.height = '10px'
	highlightEl.style.border = '2px solid red'
	highlightEl.style.borderRadius = '50%'
	highlightEl.style.zIndex = '9999'
	document.body.appendChild(highlightEl)
	setTimeout(() => {
		document.body.removeChild(highlightEl)
	}, removeAfterMs)
}

export const copyToClipboard = (text: string) => {
	if (navigator.clipboard?.writeText && window.isSecureContext) {
		return navigator.clipboard.writeText(text)
	} else {
		const textarea = document.createElement('textarea')
		textarea.value = text
		textarea.style.position = 'fixed'
		document.body.appendChild(textarea)
		textarea.select()
		document.execCommand('copy')
		document.body.removeChild(textarea)
		return Promise.resolve()
	}
}
